import { renderInlineCssVars } from '@sas/nova-commons/theme';
import React, { Fragment, useEffect, useState } from 'react';
import { Button } from '@sas/nova-commons/components/Button';
import { Flow } from '@sas/nova-commons/components/Layouts/Flow';
import { Popover } from '@sas/nova-commons/components/Popover';
import { Text } from '@sas/nova-commons/components/Text';
import { withLabels } from '@sas/nova-commons/components/withLabels';
import { BusyStateIndicator } from '@sas/nova-commons/components/BusyStateIndicator';
import { useI18n } from '../../../../locale/I18nContext';
import { AutoFocusInside } from 'react-focus-lock';
import cn from './LocationPopover.css.json';
import './LocationPopover.css';
const TextWithLabels = withLabels(Text);
export const LocationPopover = (props) => {
    var _a, _b, _c, _d;
    const [visualizationRect, setVisualizationRect] = useState(null);
    const isOpen = !!props.locationCandidate;
    useEffect(() => {
        var _a;
        let objectRect;
        if (isOpen && props.contentId) {
            objectRect = (_a = document.getElementById(props.contentId)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        }
        setVisualizationRect(objectRect !== null && objectRect !== void 0 ? objectRect : null);
    }, [isOpen, props.contentId]);
    const localize = useI18n();
    const isBusy = props.locationCandidate && !props.locationCandidate.name && !props.locationCandidate.location;
    const location = (_b = (_a = props.locationCandidate) === null || _a === void 0 ? void 0 : _a.pixelLocation) !== null && _b !== void 0 ? _b : [0, 0];
    const tokens = renderInlineCssVars({
        'with-labels-spacing-xs': -1,
    });
    const [disableLock, setDisableLock] = useState(false);
    useEffect(() => {
        setDisableLock(false);
    }, [props.locationCandidate]);
    return (React.createElement(Popover, { focusLockProps: {
            className: cn.resetCursor,
            disabled: disableLock,
        }, onEscape: props.onCancel, onOutsideClick: () => {
            setDisableLock(true);
            props.onOutsideClick();
        }, isModal: false, title: props.title, isOpen: !!props.locationCandidate, position: visualizationRect
            ? {
                left: visualizationRect.x + location[0],
                right: visualizationRect.x + location[0],
                width: 0,
                top: visualizationRect.y + visualizationRect.height - location[1],
                bottom: visualizationRect.y + visualizationRect.height - location[1],
                height: 0,
            }
            : undefined, footer: React.createElement(AutoFocusInside, null,
            React.createElement(Flow, { spacing: "s" },
                React.createElement(Button, { onPress: props.onConfirm, text: localize({ key: 'LocationPopover.ok.txt' }), disabled: isBusy }),
                React.createElement(Button, { onPress: props.onCancel, text: localize({ key: 'LocationPopover.cancel.txt' }) }))) }, isBusy ? (React.createElement(BusyStateIndicator, { active: true, delay: 0 })) : (React.createElement(Fragment, null,
        ((_c = props.locationCandidate) === null || _c === void 0 ? void 0 : _c.name) ? (React.createElement(TextWithLabels, { label: localize({ key: 'LocationPopover.name.txt' }), labelPosition: "left", wrapText: false }, props.locationCandidate.name)) : null,
        ((_d = props.locationCandidate) === null || _d === void 0 ? void 0 : _d.location) ? (React.createElement(TextWithLabels, { label: localize({ key: 'LocationPopover.location.txt' }), labelPosition: "left", wrapText: false, style: tokens }, props.locationCandidate.location)) : null))));
};
